<template>
  <div>
    <v-data-table
      :headers="headers"
      :items="list"
      :loading="loading"
      hide-actions
      class="elevation-1 mt-2"
    >
      <template slot="items" slot-scope="props">
        <td class="text-xs-left no-wrap">{{ props.item.name }}</td>
        <td class="text-xs-left">
          <v-chip
            :color="createChipColor(props.item.resourceType)"
            outline
            disabled
            text-color="black"
          >
            {{ props.item.getResourceTypeName() }}
          </v-chip>
          <span>
            {{ props.item.resourceName }}
          </span>
        </td>
        <td class="text-xs-left no-wrap">{{ props.item.inventoryCount }}</td>
        <td class="text-xs-left no-wrap">
          {{ props.item.isDefaultAttachText }}
        </td>
      </template>
      <template slot="no-data">
        <div>登録されている配信先ブラックリストはありません</div>
      </template>
    </v-data-table>
  </div>
</template>

<script>
export default {
  props: {
    list: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      headers: [
        { text: 'リスト名称', value: 'name' },
        { text: '所属', value: 'resourceName' },
        { text: '登録数', value: 'inventoryCount' },
        { text: '案件適用', value: 'isDefaultAttach' },
      ],
    }
  },
  methods: {
    createChipColor(type) {
      let result = ''
      switch (type) {
        case 'advertiser':
          result = 'pink'
          break
        case 'oem':
          result = 'success'
          break
        case 'agency':
          result = 'orange'
          break
        case 'insertion_order':
          result = 'primary'
          break
        default:
          result = 'cyan'
      }
      return result
    },
  },
}
</script>
